import React, { useEffect, useRef } from 'react';

interface AdSenseProps {
  slot: string;
  format?: 'auto' | 'fluid' | 'rectangle';
  responsive?: 'true' | 'false';
  style?: React.CSSProperties;
  className?: string;
}

const AdSense: React.FC<AdSenseProps> = ({ 
  slot, 
  format = 'auto', 
  responsive = 'true',
  style,
  className
}) => {
  const adRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    // Evita rodar no StrictMode mais de uma vez na mesma tag
    if (adRef.current && !adRef.current.hasAttribute('data-adsbygoogle-status')) {
      try {
        ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
      } catch (e) {
        if (e instanceof Error && !e.message.includes('already have ads')) {
          console.error("AdSense error:", e);
        }
      }
    }
  }, []);

  return (
    <div className={className} style={{ width: '100%', overflow: 'hidden', minHeight: '90px', ...style }}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-1830605452518717"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive}
      />
    </div>
  );
};

export default AdSense;
